import * as React from 'react'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import { makeStyles } from '@material-ui/core/styles'
import styles from 'assets/jss/dorm-app/components/departmentSignaturesStyle.js'

const useStyles = makeStyles(styles)

export default function DepartmentSignatures(props) {
  const classes = useStyles()

  const departments = ['Flursprecher', 'Barreferat', 'Finanzenreferat', 'Innenreferat', 'Werkreferat', 'Tutoren']

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell style={{ fontWeight: 600 }}>Amt</TableCell>
          <TableCell style={{ fontWeight: 600 }}>Unterschrieben am</TableCell>
          <TableCell style={{ fontWeight: 600 }}>Betrag</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {departments.map(function (department) {
          let signature = props.signatures.filter((sg) => sg.departmentName.includes(department))[0]
          return signature ? (
            <TableRow key={signature.id} className={signature.amount > 0 ? classes.dangerBackground : ''}>
              <TableCell>{signature.departmentName}</TableCell>
              <TableCell>{signature.signedOn}</TableCell>
              <TableCell>{signature.amount} Euro</TableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell>{department}</TableCell>
              <TableCell>-</TableCell>
              <TableCell>-</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
